import { useState, useEffect } from "react";
import reportStore from "../../../../stores/report-store";
import { TableRow, TableCell } from '@material-ui/core';

const TandemTransactionAnalysis = ({ date, onFetchTandemTansactionAnalysisData }) => {

    const [data, setData] = useState([]);

    // ✅ Format date (no timezone issues)
    const formatDate = (date = new Date()) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (!date) return;
        fetchData();
    }, [date]);

    const fetchData = async () => {
        try {
            const res = await reportStore.GetTandemTransactionAnalysis(formatDate(date));

            // ✅ Handle all possible API shapes safely
            const safeData = Array.isArray(res)
                ? res
                : Array.isArray(res?.data)
                    ? res.data
                    : [];

            setData(safeData);
            onFetchTandemTansactionAnalysisData?.(safeData);

        } catch (error) {
            console.error("Error fetching data:", error);
            setData([]); // prevent UI crash
        }
    };

    const renderData = (val = {}) => {
        const headings = [
            'jumperName',
            'startingBalance',
            'todayBalance',
            'todayPaid',
            'todayPayout',
            'endDayBalance'
        ];

        const amountFields = [
            'startingBalance',
            'todayBalance',
            'todayPaid',
            'todayPayout',
            'endDayBalance'
        ];

        return headings.map((key) => {
            let cellValue = val?.[key];

            if (cellValue === undefined || cellValue === null) {
                cellValue = key === 'jumperName' ? '-' : 0;
            }

            // ✅ Safe number formatting
            if (amountFields.includes(key)) {
                const num = Number(cellValue);
                cellValue = isNaN(num) ? '0.00' : num.toFixed(2);
            }

            return (
                <TableCell key={key} style={{ padding: '0.5rem 0 0 2.8rem' }}>
                    {cellValue}
                </TableCell>
            );
        });
    };

    const renderRow = () => {
        if (!Array.isArray(data) || data.length === 0) {
            return (
                <TableRow>
                    <TableCell colSpan={6} align="center">
                        No Data Found
                    </TableCell>
                </TableRow>
            );
        }

        return data.map((v, i) => (
            <TableRow key={i}>
                {renderData(v)}
            </TableRow>
        ));
    };

    return (
        <>
            {renderRow()}
        </>
    );
};

export default TandemTransactionAnalysis;